import { LicensesApi, useAPIQuery } from "melco-shared-logic";

export const useAccountGetPendingTransaction = (
    transactionId: string
    ,
    enabled: boolean,

) => {

    return useAPIQuery(LicensesApi, ["machineLicensesPendingTransaction", transactionId], async (api) => {
        if (transactionId == null) {
            return;
        }

        return api.licensesMachinePendingChanges({ transactionId: transactionId });
    }
        , {
            queryOptions: {
                enabled: enabled && !!transactionId
            }
        });
};